import React from 'react';

import ErrorComponent from './ErrorComponent';

const PageNotFound = (props) => {
  return <ErrorComponent props={props} errorCode="404"></ErrorComponent>;
};

export default PageNotFound;
